export default "__VITE_ASSET__DY_K2i2s__"